import { render, staticRenderFns } from "./LangChange.vue?vue&type=template&id=389ebc24"
import script from "./LangChange.vue?vue&type=script&lang=js"
export * from "./LangChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports